module.exports = __webpack_public_path__ + "assets/images/health_y.d6e768b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/health_y.png
// module id = 728
// module chunks = 1